enum StatusMessageVariation {
    Standard = 'standard',
    Subpage = 'subpage',
    Homepage = 'homepage',
    Short = 'short',
    WithBackground = 'with_background',
}

export default StatusMessageVariation;
